import React, {
	useContext,
	useEffect,
	useState
} from 'react';
import BC
	from "../components/BrailleCharacter";
import { DataContext } from "../store/DataProvider";
import { useTranslation } from "react-i18next";
import _ from 'lodash'

const ListView = props => {
	const { t } = useTranslation();
	const context = useContext(DataContext)
	const [list, setList] = useState({})
	const [max, setMax] = useState(0)
	const [index, setIndex] = useState(0)
	const [currentItem, setCurrentItem] = useState({ dots: [] })

	useEffect(() => {
		if (props.category) {
			var List = {};
			switch (props.system) {
				case "full":
					List = context.state.full.getCharactersByCategory(props.category, false);
					break;
				case "short":
					List = context.state.short.getKuerzungenByCategory(props.category);
					break;
				case "euro":
					List = context.state.euro.getCharactersByCategory(props.category);
					break;
				case "music":
					let pitch = props.pitch;
					let sharp = props.sharp;
					if (props.category === "music_full_notes") {
						List = context.state.music.getNotesWithPitch(pitch, false);
					} else if (props.category.startsWith("music_alterated")) {
						List = context.state.music.getNotesWithPitch(pitch, true, sharp);
					} else {
						List = context.state.music.getCharactersByCategory(props.category);
					}
					break;
				case "math":
					List = context.state.math.getCharactersByCategory(props.category);
					break;
				default:
					break;
			}
			setList(List)
			setIndex(0)
			setMax(Object.keys(List).length)
			setCurrentItem(List[Object.keys(List)[0]])
		}
	}, [context, props.system, props.category, props.pitch, props.sharp])

	const getPrev = () => {
		var i = index;
		if (i - 1 >= 0) {
			i -= 1;
		} else {
			i = max - 1;
		}
		setCurrentItem(list[Object.keys(list)[i]])
		setIndex(i)
	}
	const getNext = () => {
		var i = index;
		if (i + 1 < max) {
			i += 1;
		} else {
			i = 0;
		}
		setCurrentItem(list[Object.keys(list)[i]])
		setIndex(i)
	}

	const renderCharacter = () => {
		let characters = [];
		for (let index in currentItem.dots) {
			if (index > 0) {
				if (currentItem.dots[index] > 0) {
					characters.push(
						<BC
							key={index}
							character={
								currentItem.dots.length > 0
									? currentItem.dots[index]
									: 0
							}
							isReading={true}
							isPartOfMultipleCharacter={currentItem.dots.length > 1}
							isEuroBraille={props.system === "euro"}
							characterIndex={index}
						/>
					);
				}
			} else {
				characters.push(
					<BC
						key={index}
						character={
							currentItem.dots.length > 0
								? currentItem.dots[index]
								: 0
						}
						isReading={true}
						isPartOfMultipleCharacter={currentItem.dots.length > 1}
						isEuroBraille={props.system === "euro"}
						characterIndex={index}
					/>
				);
			}
		}
		return characters;
	}

	const renderAdditionalTexts = () => {
		var text = ""
		if(_.has(currentItem, 'exception')){
			text += currentItem.exception !== '' ? text += `Besonderheit: ${currentItem.exception}\n`: ''
		}
		if(_.has(currentItem, 'accent')){
			text += currentItem.accent !== '' ? `Umlautung: ${currentItem.accent}\n` : ''
		}
		return text
	}

	if (props.category) {
		return (
			<div>
				<div className="HStack">
					{renderCharacter()}
				</div>
				<div className='char_title text-center'>
					{currentItem.title}
				</div>
				<div className='special_container'>
					{renderAdditionalTexts()}
				</div>
				<div className='list_button_container'>
					<button class='list_button' onClick={getPrev} aria-label='vorheriger Eintrag'>&lt;</button>
					<div className='list_counter'>{`${index + 1} / ${max}`}</div>
					<button class='list_button list-button-right' onClick={getNext} aria-label='Nächster Eintrag'>&gt;</button>
				</div>
			</div>
		)
	} else {
		return (
			<h1>
				{t("common.systems." + props.system)}
			</h1>
		)
	}

}
export default ListView;